/**
 * Anzeige-Templates der Rechnungszuordnungs-View — Port von
 * `IwmColumnsRechnungszuordnung.razor`. Anders als bei Container und Bestellposition gibt
 * es hier keine Zeilenfarben (so im Original).
 */

import type { ReceiptAssignment } from '@/types/entities';

import { CheckboxCell } from './shared/CheckboxCell';
import { DateCell } from './shared/DateCell';
import type { CellTemplateMap } from './types';

export const receiptAssignmentCellTemplates: CellTemplateMap<ReceiptAssignment> = {
  // DateTimes
  Container_Eta: (model) => <DateCell value={model.Container_Eta} />,
  Container_Etd: (model) => <DateCell value={model.Container_Etd} />,
  Container_Anlieferdatum: (model) => <DateCell value={model.Container_Anlieferdatum} />,
  Container_AnlieferdatumIst: (model) => <DateCell value={model.Container_AnlieferdatumIst} />,
  Container_FruehestAnlieferdatum: (model) => (
    <DateCell value={model.Container_FruehestAnlieferdatum} />
  ),
  Container_AnlieferdatumEmpf: (model) => <DateCell value={model.Container_AnlieferdatumEmpf} />,
  Container_DatumZugestellt: (model) => <DateCell value={model.Container_DatumZugestellt} />,
  Container_DepotDatum: (model) => <DateCell value={model.Container_DepotDatum} />,

  // Booleans
  Container_EingangErledigt: (model) => <CheckboxCell value={model.Container_EingangErledigt} />,
  Container_TerminBestaetigungCif: (model) => (
    <CheckboxCell value={model.Container_TerminBestaetigungCif} />
  ),
  Container_NaechsteKw: (model) => <CheckboxCell value={model.Container_NaechsteKw} />,
};

export default receiptAssignmentCellTemplates;
